import { useRef, useState } from 'react';
import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';
import NextImage from '@/components/NextImage';
import EFVideo from '@/components/UI/EFVideo';

export default function B() {
    const { useLang } = useGlobal();
    const { t } = useLang('corporatesocialresponsibility');
    const videoRef = useRef<any>(null);
    const [playing, setPlaying] = useState(false);

    return (
        <div className={`csr-B ${css['csr-B']}`}>
            <div className="secB">
                <div className="desc">{t('secB_desc1')}</div>
                <div className="text-img">
                    <NextImage
                        src={require('@publicLocal/corporate-social-responsibility/h5/power_for_all.png')}
                        alt={t('secB_desc1')}
                        aria-label={t('secB_desc1')}
                    />
                </div>
                <div className="desc">{t('secB_desc2')}</div>
                <div className="video-wrapper">
                    <EFVideo
                        ref={videoRef}
                        className="video fullImgs"
                        sources={['/video/corporate-social-responsibility/power_for_all.mp4', '/video/corporate-social-responsibility/power_for_all.mp4']}
                        width="100%"
                        height="100%"
                        aria-label={t('secB_desc1')}
                        poster={'/media/corporate-social-responsibility/video_poster_h5.png'}
                        autoPlay={false}
                        loop={false}
                        // showReplay
                        onEnded={() => setPlaying(false)}
                        muted={false}
                        // @ts-ignore
                        controls={playing}
                    />
                    {!playing && (
                        <>
                            <div
                                className="play-icon"
                                onClick={() => {
                                    setPlaying(true);
                                    videoRef.current?.play();
                                }}
                            ></div>
                            <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 40 40" fill="none">
                                <path
                                    d="M37.6667 19.9445C37.6667 29.7322 29.7322 37.6667 19.9445 37.6667C10.1568 37.6667 2.22228 29.7322 2.22228 19.9445C2.22228 10.1568 10.1568 2.22228 19.9445 2.22228C29.7322 2.22228 37.6667 10.1568 37.6667 19.9445Z"
                                    stroke="white"
                                    strokeWidth="0.888889"
                                />
                                <path
                                    d="M15.1113 27.1691V13.6355C15.1113 12.9307 15.8923 12.5062 16.4837 12.8896L26.4559 19.3534C26.9831 19.6951 26.999 20.4611 26.4865 20.8244L16.5143 27.8942C15.9257 28.3116 15.1113 27.8907 15.1113 27.1691Z"
                                    fill="white"
                                />
                            </svg>
                        </>
                    )}
                </div>
                <p className="title">{t('secB_title')}</p>
                <div className="img">
                    <NextImage
                        webpSrc={require('@publicLocal/corporate-social-responsibility/h5/2.webp')}
                        src={require('@publicLocal/corporate-social-responsibility/h5/2.png')}
                        alt={t('secB_desc1')}
                        aria-label={t('secB_desc1')}
                    />
                    {new Array(14).fill(0).map((_: any, k: number) => (
                        <span className={`circle c${k + 1}`} key={k}>
                            <span className="inner"></span>
                        </span>
                    ))}
                </div>
            </div>
        </div>
    );
}
